import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import { getToken } from "../../utils/localStorageMethods";

const apiUrl = config.Url;

const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/manual-payment/`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("ngrok-skip-browser-warning", "true");
    }
    return headers;
  },
});

export const manualPaymentSlice = createApi({
  reducerPath: "manualPaymentSlice",
  baseQuery,
  tagTypes: ["manualPayment"],
  endpoints: (builder) => ({
    initiateManualPayment: builder.mutation({
      query: (data) => ({
        url: "initiate",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["manualPayment"],
    }),

    verifyManualPayment: builder.mutation({
      query: (data) => ({
        url: "verify",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["manualPayment"],
    }),

    getManualPayments: builder.query({
      query: ({ page, limit, status, payer_id, recipient_id, from_date, to_date } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (status) params.append("status", status);
        if (payer_id) params.append("payer_id", payer_id);
        if (recipient_id) params.append("recipient_id", recipient_id);
        if (from_date) params.append("from_date", from_date);
        if (to_date) params.append("to_date", to_date);
        return `?${params.toString()}`;
      },
      providesTags: ["manualPayment"],
    }),

    getManualPaymentById: builder.query({
      query: (id) => `${id}`,
      providesTags: ["manualPayment"],
    }),

    completeManualPayment: builder.mutation({
      query: (manual_payment_id) => ({
        url: "complete",
        method: "POST",
        body: { manual_payment_id },
      }),
      invalidatesTags: ["manualPayment"],
    }),

    deleteManualPayment: builder.mutation({
      query: (id) => ({ url: `${id}`, method: "DELETE" }),
      invalidatesTags: ["manualPayment"],
    }),
  }),
});

export const {
  useInitiateManualPaymentMutation,
  useVerifyManualPaymentMutation,
  useGetManualPaymentsQuery,
  useGetManualPaymentByIdQuery,
  useCompleteManualPaymentMutation,
  useDeleteManualPaymentMutation,
} = manualPaymentSlice;
